<template>
    <div v-if="visible"
         class="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50"
         style="z-index: 9999;"
    >
        <div class="shop-loading-container">
            <div class="loader"></div>
        </div>

        <p class="pt-2 text-white">
            {{ __('Kis türelmet kérünk, dolgozunk!') }}
        </p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
        }
    },

    methods: {
        show() {
            this.visible = true
        },

        hide() {
            this.visible = false
        },
    }
}
</script>

<style scoped lang="scss">
.shop-loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    background: #fff;
    border-radius: 50%;

    div.loader {
        width: 60px;
        aspect-ratio: 2;
        --_g: no-repeat radial-gradient(circle closest-side,#b2d630 90%,#b2d63000);
        background:
            var(--_g) 0%   50%,
            var(--_g) 50%  50%,
            var(--_g) 100% 50%;
        background-size: calc(100%/3) 50%;
        animation: shop-loading-animation 1s infinite linear;
    }

    @keyframes shop-loading-animation {
        20%{background-position:0%   0%, 50%  50%,100%  50%}
        40%{background-position:0% 100%, 50%   0%,100%  50%}
        60%{background-position:0%  50%, 50% 100%,100%   0%}
        80%{background-position:0%  50%, 50%  50%,100% 100%}
    }
}
</style>
